module.exports = __webpack_public_path__ + "static/img/profile-background.fd9aa71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/profile-background.jpg
// module id = 5R7F
// module chunks = 0